import { RichTextEditor as MantineRichTextEditor, RichTextEditorControlProps } from "@mantine/tiptap";
import clsx from "clsx";
import { FunctionComponent } from "react";
import styles from "../rich-text-editor.module.scss";
import { faBlockQuote } from "@fortawesome/pro-solid-svg-icons";
import { Icon } from "../../icon";
import { useEditorDisabled } from "../use-editor-disabled";

const BlockquoteIcon = () => <Icon icon={faBlockQuote} size="xs" />;

export const Blockquote: FunctionComponent<RichTextEditorControlProps> = ({ className, disabled, ...other }) => {
    const effectiveDisabled = useEditorDisabled(disabled);
    return (
        <MantineRichTextEditor.Blockquote
            className={clsx(styles["control"], className)}
            disabled={effectiveDisabled}
            {...other}
            icon={BlockquoteIcon}
        />
    );
};

Blockquote.displayName = "RichTextEditor.Blockquote";
